import { vdkEmHappinessPortalApi } from "./vdk-em-happiness-portal-api";
import { convertModelToFormData } from "@application/helpers/form-data-helper";
const mapCreatePartnerEventToApi = (request) => {
    const mapped = {
        PartnerId: request.partnerId,
        Title: request.title,
        Location: request.location,
        BackgroundImages: request.backgroundImages,
        StartDate: request.startDate,
        EndDate: request.endDate,
        StartTime: request.startTime,
        EndTime: request.endTime,
        DueRegistrationDate: request.dueRegistrationDate,
        IsExternalAllowed: request.isExternalAllowed,
        IsPasswordProtection: request.isPasswordProtection,
        Password: request.password,
        EventCompanyIds: request.eventCompanyIds,
        CollaboratorIds: request.collaboratorIds,
        InterestIds: request.interestIds,
        BenefitType: Number(request.benefitType),
        languageIds: request.languageIds
    };
    return mapped;
};
const mapUpdatePartnerEventToApi = (request) => {
    const mapped = {
        Id: request.id,
        Title: request.title,
        Location: request.location,
        BackgroundImages: request.backgroundImages,
        ExistingImages: request.existingImages,
        StartDate: request.startDate,
        EndDate: request.endDate,
        StartTime: request.startTime,
        EndTime: request.endTime,
        DueRegistrationDate: request.dueRegistrationDate,
        IsExternalAllowed: request.isExternalAllowed,
        IsPasswordProtection: request.isPasswordProtection,
        Password: request.password,
        EventCompanyIds: request.eventCompanyIds,
        CollaboratorIds: request.collaboratorIds,
        InterestIds: request.interestIds,
        BenefitType: Number(request.benefitType),
        IsSponsorPartnerEvent: request.isSponsorPartnerEvent,
        isSponsorPartnerExternalEvent: request.isSponsorPartnerExternalEvent,
        languageIds: request.languageIds
    };
    return mapped;
};
const createPartnerEvent = (request) => {
    const formData = convertModelToFormData(mapCreatePartnerEventToApi(request));
    return vdkEmHappinessPortalApi.post('/partners-event/create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const updatePartnerEvent = (request) => {
    const formData = convertModelToFormData(mapUpdatePartnerEventToApi(request));
    return vdkEmHappinessPortalApi.post('/partners-event/update', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};
const getPartnerEvents = (request) => {
    return vdkEmHappinessPortalApi.post('/partners-event/get-monthly', request);
};
const getPartnerEventDetails = (request) => {
    return vdkEmHappinessPortalApi.post(`/partners-event/get-details/${request}`);
};
const partnerEventAPI = {
    createPartnerEvent,
    updatePartnerEvent,
    getPartnerEvents,
    getPartnerEventDetails
};
export default partnerEventAPI;
